import { cva } from 'class-variance-authority';

export const BUTTON_VARIANTS = cva(
  'inline-flex items-center justify-center font-semibold gap-2 disabled:cursor-not-allowed disabled:bg-neutral-n2 disabled:text-neutral-n6 disabled:border disabled:boder-solid disabled:border-neutral-n4 hover:shadow-[inset_0px_250px_0px_0px_rgba(3,21,47,0.05)] active:shadow-[inset_0px_250px_0px_0px_rgba(3,21,47,0.1)] focus:shadow-[0_0_0_2px_#90C2FC]',
  {
    variants: {
      variant: {
        primary: 'bg-brand-primary-base text-neutral-white',
        secondary:
          'bg-neutral-white text-brand-primary-base border border-solid border-brand-primary-base',
        cancel: 'bg-neutral-white text-brand-primary-darkest border border-solid border-neutral-n6',
        error: 'bg-semantic-error-base text-neutral-white',
        success: 'bg-semantic-success-base text-neutral-white',
        link: '!px-0 min-h-0 bg-transparent text-brand-primary-base hover:bg-transparent hover:shadow-none active:shadow-none focus:shadow-none disabled:bg-transparent disabled:border-none',
      },
      size: {
        default: 'text-sm px-base [&:not([data-variant=link])]:min-h-xl',
        sm: 'text-xs px-s [&:not([data-variant=link])]:min-h-l',
        lg: 'text-base px-base [&:not([data-variant=link])]:min-h-xxl',
      },
      borderRadius: {
        default: 'rounded-[100px]',
        square: 'rounded-none',
        soft: 'rounded-soft',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
      borderRadius: 'default',
    },
  },
);

export const ICON_VARIANTS = cva('inline-flex items-center', {
  variants: {
    size: {
      default: '[&_*]:w-auto [&_*]:h-5',
      sm: '[&_*]:w-auto [&_*]:h-4',
      lg: '[&_*]:w-auto [&_*]:h-6',
    },
  },
});
